// extracted by mini-css-extract-plugin
export default {"button":"ReturnButton_button__vcydq"};